import { render, staticRenderFns } from "./EditStop.vue?vue&type=template&id=acdd0d88&"
import script from "./EditStop.vue?vue&type=script&lang=js&"
export * from "./EditStop.vue?vue&type=script&lang=js&"
import style0 from "./EditStop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VTextField})
